import React, { useMemo } from 'react';
import ReactApexChart from 'react-apexcharts';
import type { ApexOptions } from 'apexcharts';

type PriseItem = { quantite?: number };

type PrisesType = Record<
    string,
    {
        gasoil?: PriseItem;
        essence?: PriseItem;
        autres?: PriseItem;
    }
>;

const labels = ['Gasoil', 'Essence', 'Autres'];
const colors = ['#00A65A', '#FFD700', '#888888'];

const PrisesPieChart: React.FC<{ prises?: PrisesType; height?: number }> = ({ prises = {}, height = 360 }) => {
    const totals = useMemo(() => {
        const acc = { gasoil: 0, essence: 0, autres: 0 };
        Object.values(prises).forEach((m) => {
            acc.gasoil += m?.gasoil?.quantite ?? 0;
            acc.essence += m?.essence?.quantite ?? 0;
            acc.autres += m?.autres?.quantite ?? 0;
        });
        return [acc.gasoil, acc.essence, acc.autres];
    }, [prises]);

    const sum = totals.reduce((a, b) => a + b, 0);

    const options: ApexOptions = useMemo(() => {
        return {
            chart: {
                type: 'pie',
                toolbar: { show: false },
            },
            labels,
            colors,
            legend: {
                position: 'top',
                horizontalAlign: 'center',
            },
            dataLabels: {
                enabled: true,
                formatter: (val, opts) => {
                    const idx = (opts as any).seriesIndex as number;
                    const absolute = totals[idx] ?? 0;
                    if (sum === 0) return '0';
                    const pct = ((absolute / sum) * 100).toFixed(1);
                    return `${absolute.toFixed(2)} (${pct}%)`;
                },
            },
            tooltip: {
                y: {
                    formatter: (val) => `${val}`,
                },
            },
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        legend: { position: 'bottom' },
                    },
                },
            ],
        } as ApexOptions;
    }, [totals, sum]);

    if (sum === 0) {
        return <div className="alert alert-warning">Pas de données à afficher</div>;
    }

    return <ReactApexChart options={options} series={totals} type="pie" height={height} />;
};

export default PrisesPieChart;
